import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { GameScene } from './scenes/GameScene';
import { PauseScene } from './scenes/PauseScene';
import { GameOverScene } from './scenes/GameOverScene';
import { HighScoreScene } from './scenes/HighScoreScene';
import { HighScoreEntryScene } from './scenes/HighScoreEntryScene';
import { GAME_CONFIG } from './config/gameConfig';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_CONFIG.width,
  height: GAME_CONFIG.height,
  backgroundColor: GAME_CONFIG.backgroundColor,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    min: {
      width: GAME_CONFIG.width / 2,
      height: GAME_CONFIG.height / 2,
    },
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    TitleScene,
    GameScene,
    PauseScene,
    GameOverScene,
    HighScoreScene,
    HighScoreEntryScene,
  ],
  input: {
    gamepad: true,
  },
  render: {
    pixelArt: false,
    antialias: true,
  },
  fps: {
    target: 60,
    forceSetTimeOut: false,
  },
  audio: {
    disableWebAudio: false,
  },
};

let game: Phaser.Game;

try {
  game = new Phaser.Game(config);
} catch (e) {
  // If game creation fails with audio enabled, retry with audio disabled
  console.warn('Game initialization failed, retrying with audio disabled:', e);
  config.audio = { disableWebAudio: true, noAudio: true };
  game = new Phaser.Game(config);
}

// Expose game instance for debugging/testing
(window as unknown as Record<string, unknown>).__PHASER_GAME__ = game;

export default game;
